import { CALCULATE_FINANCE_PAYMENTS } from './calculateFinancePayments';
import { GET_ELIGIBLE_FINANCE_PROGRAMS } from './getEligibleFinancePrograms';

export const lenderDeskingApi = {
  calculate: CALCULATE_FINANCE_PAYMENTS,
  getEligibleFinancePrograms: GET_ELIGIBLE_FINANCE_PROGRAMS,
};

export * from './useCalculate';
export * from './useEligibleFinancePrograms';
